import { useEffect, useState, type ReactNode } from 'react'
import { ThemeContext } from '@/contexts'
import { useLocation } from '@tanstack/react-router'
import withMFD from '@/components/withMFD'
import { getNestedProp } from '@/helpers'
import deepEqual from 'fast-deep-equal'

interface ThemeProviderProps {
  mfd?: any
  children?: ReactNode
}

function ThemeProvider(props: ThemeProviderProps) {
  const location = useLocation()

  const getCurrentTheme = () => {
    const game = location.pathname.split('/').filter(_ => _)[0]

    return getNestedProp(
      props,
      `mfd.settings[${game}].theme`
    )
  }

  const [theme, setTheme] = useState(getCurrentTheme())

  useEffect(() => {
    const currentTheme = getCurrentTheme()

    if (!deepEqual(theme, currentTheme)) {
      setTheme(() => currentTheme)
    }
  }, [props.mfd, props.mfd?.settings])

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  )
}

export default withMFD(ThemeProvider as any)
